export default [
  {
    path: '/data/clients',
    name: 'Client',
    component: () => import('@/views/admin/clients/Index.vue'),
    meta: {
      rule: 'editor',
      pageTitle: 'Clients',
      breadcrumb: [{
          title: 'Home',
          url: '/'
        },
        {
          title: 'Data'
        },
        {
          title: 'Clients',
          active: true
        },
      ],
    }
  },
  {
    path: '/data/staff',
    name: 'Staff',
    component: () => import('@/views/admin/staff/Index.vue'),
    meta: {
      rule: 'editor',
      pageTitle: 'Staff',
      breadcrumb: [{
          title: 'Home',
          url: '/'
        },
        {
          title: 'Data'
        },
        {
          title: 'Staff',
          active: true
        },
      ],
    }
  },
]
